import { render, staticRenderFns } from "./Quote.vue?vue&type=template&id=c19f7ab4&scoped=true&"
var script = {}
import style0 from "./Quote.vue?vue&type=style&index=0&id=c19f7ab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19f7ab4",
  null
  
)

export default component.exports